// extracted by mini-css-extract-plugin
module.exports = {"cornerButtonContainer":"_adf2f3e","cornerButton":"_f37bbd4","info":"_576d392","touch":"_3ed625d"};